module.exports = __webpack_public_path__ + "static/media/personal_folder_p1_1.10316ed6.png";